<template>
    <v-container fluid>
        <v-row>
            <v-col class="pl-0" cols="8" sm="9" md="10">
                <v-select
                    dense
                    v-model="selectedResource"
                    :item-text="item => item.title"
                    :items="resourcesTypes"
                    label="Seleccione tipo de recurso"
                    outlined
                    rounded
                    :disabled="this.disabled"
                ></v-select>
            </v-col>
            <v-col cols="4" sm="3" md="2">
                <v-btn
                    :disabled="!checkEmptyResource"
                    color="primary"
                    rounded
                    dense
                    @click="addComponent()"
                    class="add-resource-btn"
                >
                    <span>Añadir</span>
                    <v-icon dark class="d-none d-sm-flex">mdi-plus</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <!-- dynamic resources -->
        <template v-if="getResources.length">
            <v-row v-for="(item, i) in getResources" :key="i">
                <v-col cols="11">
                    <template v-if="item">
                        <component
                            :is="item.data.component"
                            :uid="item.uid"
                            :data="setData"
                            :content="item.content"
                            placeholder="Recurso de Texto"
                        ></component>
                    </template>
                </v-col>
                <v-col cols="1">
                    <v-btn
                        class="mx-2 mt-2"
                        fab
                        dark
                        small
                        color="primary"
                        @click="removeComponent(item)"
                        v-if="!disabled"
                    >
                        <v-icon dark>mdi-minus</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import RomaWyswyg from "@/components/core/RomaWyswyg.vue";
import RomaDocument from "@/components/core/RomaDocument";
import RomaVideoLink from "@/components/core/RomaVideoLink";
import RomaVideo from "@/components/core/RomaVideo";
import RomaDocumentLink from "@/components/core/RomaDocumentLink";
import RomaDocumentLinkEmbedded from "@/components/core/RomaDocumentLinkEmbedded";
import ResourcesMixin from "@/mixins/resourcesMixin";
import { mapActions, mapGetters } from "vuex";
export default {
    props: {
        data: {
            required: false
        },
        content: {
            required: false
        },
        resourcesTO: {
            required: false
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    mixins: [ResourcesMixin],
    data() {
        return {
            selectedResource: {},
            resources: [
                {
                    id: 1,
                    title: "Texto",
                    content: "",
                    component: RomaWyswyg
                },
                {
                    id: 2,
                    title: "Enlace de vídeo",
                    content: "",
                    component: RomaVideoLink
                },
                {
                    id: 3,
                    title: "Archivo de vídeo",
                    content: "",
                    component: RomaVideo
                },
                {
                    id: 4,
                    title: "Enlace de documento",
                    content: "",
                    component: RomaDocumentLink
                },
                {
                    id: 5,
                    title: "Archivo de documento",
                    content: "",
                    component: RomaDocument
                }
            ],
            resourcesTypes: []
        };
    },
    mounted() {
        this.getAllResourceTypes().then(res => {
            this.resourcesTypes = this.getResourcesTypes;
            this.pruebaResourcesTypes(this.resourcesTypes);
        });
    },
    watch: {
        resourcesTO() {
            this.loadResources();
        }
    },
    computed: {
        ...mapGetters({
            getResourcesTypes: "getResourcesTypes"
        }),
        component() {
            const resource = this.resourcesTypes.find(
                resource => resource.title === this.selectedResource
            );
            return resource ? resource : "";
        },
        checkEmptyResource() {
            return !!Object.keys(this.selectedResource).length;
        }
    },
    methods: {
        ...mapActions({
            getAllResourceTypes: "getAllResourceTypes"
        }),
        setData(data, uid) {
            this.setResources({
                data,
                uid
            });
        },
        addComponent() {
            this.addNewResource({
                uid: this.getRandomInt(0, 10000) + this.getResources.length,
                content: null,
                data: this.component
            });
        },
        removeComponent(component) {
            this.removeResource(component);
        },
        pruebaResourcesTypes(el) {
            el.forEach((resource, i) => {
                if (resource.type === "FILE") {
                    resource.component = RomaDocument;
                } else if (resource.type === "VIDEO_LINK") {
                    resource.component = RomaVideoLink;
                } else if (resource.type === "TEXT") {
                    resource.component = RomaWyswyg;
                } else if (resource.type === "EXTERNAL_LINK") {
                    resource.component = RomaDocumentLink;
                } else if (resource.type === "EXTERNAL_LINK_EMBEDDED") {
                    resource.component = RomaDocumentLinkEmbedded;
                }
                resource.title = this.capitalizeFirstLetter(resource.name);
                resource.id = i;
                resource.content = "";
            });
        },
        loadResources() {
            this.resourcesTO.forEach(element => {
                const component = this.resourcesTypes.find(
                    resource =>
                        resource.resourceTypeId ===
                        element.resourceType.resourceTypeId
                );

                let contenido = null;

                switch (element.resourceType.name) {
                    case "ARCHIVO":
                        contenido = new File([""], element.fileName, {
                            type: "text/plain"
                        });
                        break;

                    case "VIDEO ENLACE":
                        contenido = element.link;
                        break;

                    case "TEXTO ENRIQUECIDO":
                        contenido = element.description;
                        break;

                    case "ENLACE EXTERNO":
                        contenido = element.link;
                        break;

                    case "ENLACE EXTERNO EMBEBIDO":
                        contenido = element.link;
                        break;

                    default:
                        console.log("ERROR EN EL TIPO DE RECURSO");
                        break;
                }
                this.addNewResource({
                    resourcesId: element.resourcesId,
                    path: element.path,
                    uid: this.getRandomInt(0, 10000) + this.getResources.length,
                    content: contenido,
                    data: component
                });
            });
        }
    }
};
</script>

<style lang="scss">
.custom-col {
    display: grid;
    align-items: center;
    grid-template-columns: 1fr max-content;
    grid-gap: 2rem;
    .add-resource-btn {
        transform: translateY(-14px);
    }
}
</style>
